/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RiskMCPPlatformTool,
  RiskMCPPlatformTool$inboundSchema,
} from "./riskmcpplatformtool.js";

export type RiskMCPPlatformToolset = {
  /**
   * The stable policy-scope identity for this Platform MCP toolset.
   */
  id: string;
  /**
   * The display name for this Platform MCP toolset.
   */
  name: string;
  /**
   * The reserved Platform MCP toolset slug.
   */
  slug: string;
  /**
   * The code-owned tools in this Platform MCP toolset.
   */
  tools: Array<RiskMCPPlatformTool>;
};

/** @internal */
export const RiskMCPPlatformToolset$inboundSchema: z.ZodMiniType<
  RiskMCPPlatformToolset,
  unknown
> = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  tools: z.array(RiskMCPPlatformTool$inboundSchema),
});

export function riskMCPPlatformToolsetFromJSON(
  jsonString: string,
): SafeParseResult<RiskMCPPlatformToolset, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskMCPPlatformToolset$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskMCPPlatformToolset' from JSON`,
  );
}
